import { BUILD_ENV } from "../../shared/constants/environment";

// Mirrors the users-repo authenticationRedirectMap (PR #2511) — no dev/local
// entry exists there either.
const V3_APP_ORIGIN_BY_ENV: Partial<Record<string, string>> = {
  production: "https://my-v3.wingspan.app",
  staging: "https://staging-my-v3.wingspan.app",
  integration: "https://integration-my-v3.wingspan.app"
};

export function shouldRedirectToV3(params: {
  migrateToV3?: boolean;
  authenticationStrategy: "Password" | "SingleSignOn";
}): boolean {
  return !!params.migrateToV3;
}

export function buildV3SignInUrl(email: string): string | null {
  const origin = V3_APP_ORIGIN_BY_ENV[BUILD_ENV as string];
  if (!origin) {
    return null;
  }
  return `${origin}/member/sign-in?email=${encodeURIComponent(email)}`;
}

export function redirectToV3SignIn(email: string): boolean {
  const url = buildV3SignInUrl(email);
  if (!url) {
    return false;
  }
  window.open(url, "_self");
  return true;
}
